
<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-06 09:45:07
 * @LastEditTime : 2025-10-24 11:28:28
 * @LastEditors  : yangxr
 * @Description 材料进销存
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accountingSheet\purchaseSaleStore.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main v-loading="mainLoading" style="display: flex">
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">时间</span>
              <el-date-picker v-model="tableParams.businessTime" style="width: 150px;" type="month" unlink-panels
                value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">站点</span>
              <el-select ref="selection" v-model="tableParams.stationIds" style="width: 250px" multiple filterable
                clearable>
                <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                  :value="item.stationId"></el-option>
              </el-select>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">主体</span>
              <el-select ref="mianBodyId" v-model="tableParams.mianBodyId" style="width: 200px" filterable clearable
                @change="$nextTick(() => { tableParams.mianBody = $refs.mianBodyId.selectedLabel })">
                <el-option v-for="item in mainBodyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
            <el-button style="margin-left: 24px" icon="el-icon-search" size="medium" class="bottom_all"
              @click="getBasicData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="downLoad()">导出</el-button>
            <el-button icon="el-icon-plus" size="medium" class="bottom_all" style=" position: absolute;right: 50px;"
              @click="generateForm()">生成业务记账单</el-button>
          </div>
          <div class="hr"></div>
          <div v-loading="tableLoading" :style="style">
            <tableMain ref="tableMain" key="3" :tableData="tableData" :height="screenHeight - 260" />
          </div>
          <div style="position: fixed; top: -10000px;left:10000px">
            <tableMain ref="tableMain1" key="1" :tableData="tableData1" />
            <tableMain ref="tableMain2" key="2" :tableData="tableData2" />
          </div>
          <!-- 业务记账单 -->
          <approvalForm ref="approvalForm" :dialog.sync="approvalFormDialog" :params="tableParams"
            @openDialog="openDialog" @resetForm="resetForm" @mainLoadingClose="mainLoadingClose" />
        </div>
      </el-main>
    </el-container>

  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import tableMain from "./tableMain.vue";
import html2canvas from 'html2canvas';
import { uploadFile } from "@/api/common.js";
import approvalForm from ".//report/approvalForm";
import { queryAllStation, querymainBodyList, queryBasicData,businessSingleExportList } from "@/api/docking.js";
export default {
  components: {
    tableMain,
    approvalForm
  },
  mixins: [mixin],
  data() {
    return {
      pagesType: 0,
      tableParams: {
        businessTime: "",//日期(必传)
        mianBodyId: "",
        mianBody: "",
        stationIds: [],
        modeType: "", //模式（非必传，模式: 1 购买；2委托加工）
      },
      tableData: [],
      tableData1: [],//生成图片所需数据
      tableData2: [],//生成图片所需数据
      mainBodyList: [],
      stationList: [],
      tableLoading: false,
      mainLoading: false,
      accountingFormDig: false,
      accountingForm: {},
      accountingFormRules: {},
      approvalFormDialog: false,
      imgStatus: 0,//0未生成 1已生成1个 2已生成完成
    };
  },
  watch: {
  },
  async created() {
    queryAllStation().then(res => {
      if (res.code == 1001) {
        this.stationList = res.data
      }
    })
    querymainBodyList().then(res => {
      if (res.code == 1001) {
        this.mainBodyList = res.data
      }
    })
    const query = this.$route.query
    if (query.mainBodyId && query.businessTime && query.mainBodyName) {
      this.tableParams.mianBody = query.mainBodyName
      this.tableParams.mianBodyId = query.mainBodyId
      this.tableParams.businessTime = query.businessTime
      this.getBasicData()
    }
  },
  methods: {
    downLoad() {
      this.$Download2(businessSingleExportList, this.tableParams);
    },
    openDialog() {
      this.approvalFormDialog = true
      this.mainLoadingClose()
    },
    mainLoadingClose() {
      this.mainLoading = false
    },
    resetForm() {
      this.approvalFormDialog = false
    },
    generateImg(modeType) {
      this.$nextTick(() => {
        new Promise(resolve => {
          const table = modeType == 1 ? this.$refs.tableMain1.$el : this.$refs.tableMain2.$el
          html2canvas(table).then(canvas => {
            canvas.toBlob(blob => {
              const file = new File([blob], "材料进销存.jpg", { type: "image/jpg" });
              const params = new FormData();
              params.append("file", file);
              uploadFile(params).then(res => {
                if (res.code === 1001) {
                  resolve(res.data);
                }
              });
            });
          });
        }).then(res2 => {
          res2.fileUrl = 'https://lvshe.huashijc.com/file/' + res2.fileUrl
          console.log(res2.fileUrl)
          if (modeType == 1) {
            this.tableParams['file1'] = res2.fileUrl  //1 购买；2委托加工
          }
          if (modeType == 2) {
            this.tableParams['file2'] = res2.fileUrl
          }
          this.imgStatus++;
          if (this.imgStatus == 2) {
            this.$refs.approvalForm.initData()
          }
        });
      });
    },
    async generateForm() {

      // this.openDialog()

      this.imgStatus = 0
      this.mainLoading = true
      this.getBasicData()
      this.$refs.approvalForm.initData()
      // await this.getBasicData(1)
      // await this.getBasicData(2)


    },
    async getBasicData(modeType) {
      if (!this.tableParams.businessTime) {
        this.$message.warning('时间不能为空！')
        return
      }
      if (!this.tableParams.mianBodyId) {
        this.$message.warning('主体不能为空！')
        return
      }
      if (modeType) {
        this.tableParams.modeType = modeType
      } else {
        this.tableParams.modeType = ""
        this.tableLoading = true
      }
      let res = await queryBasicData(this.tableParams)
      if (res.code == 1001) {
        res.data.sort((a, b) => {
          // 依次比较站点、时间、主体、大类
          if (a.stationName !== b.stationName) {
            return a.stationName.localeCompare(b.stationName);
          }
          if (a.businessTime !== b.businessTime) {
            return a.businessTime.localeCompare(b.businessTime);
          }
          if (a.mianBodyName !== b.mianBodyName) {
            return a.mianBodyName.localeCompare(b.mianBodyName);
          }
          return a.materil.localeCompare(b.materil);
        });
        if (modeType == 1) {
          this.tableData1 = res.data
          this.generateImg(modeType)
        } else if (modeType == 2) {
          this.tableData2 = res.data
          this.generateImg(modeType)
        } else {
          this.tableData = res.data
        }
      }
      this.tableLoading = false
    },
    init() {
      this.tableParams = this.$options.data().tableParams
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
